// Busca do cardápio do totem: campo grande + teclado de letras na tela (o
// totem não tem teclado físico). Fica acima da grade, que filtra ao vivo.
import { Search, X } from "lucide-react";

import BotaoApagar from "../BotaoApagar";
import TecladoAlfabetico from "../TecladoAlfabetico";

export default function BuscaProdutos({ searchTerm, setSearchTerm, onFechar, total, onCodigo }) {
  // Balcão: código de barras digitado à mão + Enter lança o produto, igual ao
  // leitor (o leitor em si é tratado antes, em hooks/useLeitorBalcao).
  const enterComCodigo = (e) => {
    const codigo = searchTerm.replace(/\s/g, "");
    if (e.key !== "Enter" || !onCodigo || !/^\d{4,}$/.test(codigo)) return;
    e.preventDefault();
    onCodigo(codigo);
    setSearchTerm("");
  };
  return (
    <div className="px-4 pt-4 space-y-3" data-e2e="painel-busca">
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-zinc-500" />
        <input
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={enterComCodigo}
          placeholder="Digite o nome do produto"
          inputMode="none"
          autoFocus
          data-e2e="busca-input"
          style={{ fontSize: "1.5rem" }}
          className="w-full h-16 pl-14 pr-20 font-bold rounded-2xl bg-zinc-900 border-2 border-zinc-700 text-zinc-100 placeholder:text-zinc-600 focus:border-primary focus:outline-none"
        />
        <BotaoApagar onApagar={() => setSearchTerm(searchTerm.slice(0, -1))} onLimpar={() => setSearchTerm("")} desabilitado={!searchTerm} />
      </div>
      <TecladoAlfabetico
        onLetra={(l) => setSearchTerm(searchTerm + l.toLowerCase())}
        onEspaco={() => setSearchTerm(searchTerm.endsWith(" ") || !searchTerm ? searchTerm : searchTerm + " ")}
      />
      <div className="flex items-center justify-between text-sm text-zinc-400">
        <span data-e2e="busca-total">{searchTerm ? `${total} produto${total === 1 ? "" : "s"} encontrado${total === 1 ? "" : "s"}` : "Mostrando todos os produtos"}</span>
        <button type="button" onClick={onFechar} data-e2e="busca-fechar" className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-zinc-200 font-semibold"><X className="w-4 h-4" /> Fechar busca</button>
      </div>
    </div>
  );
}
